import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { Button, message, Modal, Switch } from 'antd';
import { createContext, FC, ReactNode, useContext, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Distances } from '../components/distances';
import { LayoutSite } from '../components/layout';
import { Loader } from '../components/loader';
import { RacePlayer } from '../components/raceplayer';
import { Progress } from '../components/raceprogress';
import { Ranking } from '../components/ranking';
import { Sections } from '../components/sections';
import { Speeds } from '../components/speeds';
import { Top5 } from '../components/top5';
import { get_race } from '../services/api.service';
import { getToken } from '../services/auth.header';
import { ApiRace, ApiRunner, findcolor, formatdateYYYYMMDD, RaceDatas, RunnerPosition, SpeedDatas } from '../types';
import { WebClient } from '../webclient';
import './race.scss';

const API_KEY = 'AIzaSyAYJ0T0QfMpPex9whIoratlZIIiEaJXAq8';

const MAP_CENTER = { lat: 43.628908, lng: 3.909600 };
const MAP_STYLE = { width: "100%", height: "100%" };
const MAP_ZOOM = 16;

const MAP_OPTIONS = {
    streetViewControl: false,
    mapTypeId: 'satellite',
    scaleControl: true,
    fullscreenControl: true,
    fullscreenControlOptions: { position: 6.0},
    gestureHandling: "greedy",
    disableDoubleClickZoom: true,
    minZoom: 3,
    maxZoom: 20,
    mapTypeControl: false,
    zoomControl: true,
    clickableIcons: false,
    disableDefaultUI: true
};

/* -------------------------------------------------------------------------------- *\
|                               SpeedDatas
\* -------------------------------------------------------------------------------- */
export class RunnerSpeedDatas
{
    public number: number = 0;
    public speed: number = 0;
    public hr: number = 0;
    public speeds: SpeedDatas | null = null;
    public last_x: number = 0;
    public last_y: number = 0;
    public last_xhr: number = 0;
    public last_yhr: number = 0;
    public static maxspeedkmh: number = 20;
    public static maxspeed: number = this.maxspeedkmh / 3.6;
    public static maxhr: number = 100;

    public selected: boolean = true;
}
/* -------------------------------------------------------------------------------- *\
|                               SpeedsContext
\* -------------------------------------------------------------------------------- */
export const SpeedsContext = createContext<RunnerSpeedDatas[]>([]);
export const useSpeedsContext = () =>
{
    return useContext(SpeedsContext);
};
/* -------------------------------------------------------------------------------- *\
|                               RacesContext
\* -------------------------------------------------------------------------------- */
export const RacesContext = createContext<RaceDatas | null>(null);
export const useRacesContext = () =>
{
    return useContext(RacesContext);
};
var g_lat = 0;
var g_lng = 0;

const DOWNLOAD_STEPS: { state: string, pct: number }[] =
[
    { state: 'looking for data file...', pct: 5  },
    { state: 'decoding...',              pct: 95 },
    { state: 'compacting...',            pct: 98 },
    { state: 'ready',                    pct: 100 },
];

// "transfering" occupe la plage 10-70%, interpolée avec downloadprogress (0-100)
function getDownloadPct(state: string, transferprogress: number): number
{
    if (state.startsWith('transfering')) return 5 + transferprogress * 0.9;
    const step = DOWNLOAD_STEPS.find(s => state.startsWith(s.state));
    return step ? step.pct : (state.startsWith('error') ? 0 : 0);
}

/* -------------------------------------------------------------------------------- *\
|                               markerIconCache
\* -------------------------------------------------------------------------------- */
const markerIconCache = new Map<number, string>();

function getMarkerIcon(number: number, color: { color: string, border: string, font: string }): string
{
    if (markerIconCache.has(number)) return markerIconCache.get(number)!;
    const canvas = document.createElement('canvas');
    canvas.width = 20;
    canvas.height = 20;
    const ctx = canvas.getContext('2d')!;
    ctx.beginPath();
    ctx.arc(10, 10, 10, 0, Math.PI * 2);
    ctx.fillStyle = '#' + color.color;
    ctx.fill();
    // ctx.strokeStyle = '#' + color.border;
    // ctx.lineWidth = 1;
    // ctx.stroke();
    ctx.fillStyle = '#' + color.font;
    ctx.font = 'bold 11px Arial';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(String(number), 10, 11);
    const url = canvas.toDataURL();
    markerIconCache.set(number, url);
    return url;
}
/* -------------------------------------------------------------------------------- *\
|                               RacePage
\* -------------------------------------------------------------------------------- */
export const RacePage: FC<{ children?: ReactNode }> = ({ children }) =>
{
    const params = useParams();
    const date: string = params.date!;
    const track: string = params.track!;
    const raceno: number = Number(params.raceno ? params.raceno : "0");
    
    const [loading, setLoading] = useState(true);

    const [races, setRaces] = useState<RaceDatas | null>(null);
    const [racessmall, setRacessmall] = useState<RaceDatas | null>(null);
    const [racedatas, setRaceDatas] = useState<RaceDatas | null>(null);
    const [speeds, setSpeeds] = useState<RunnerSpeedDatas[]>([]);
    
    const [competitors, setCompetitors] = useState<ApiRunner[]>([]);

    const [currenttab, setCurrentTab] = useState<string>("speeds");

    const [showplayer, setShowplayer] = useState<boolean>(false);
    const [downstate, setDownstate] = useState<string>('');
    const [downloadprogress, setDownloadprogress] = useState<number>(0);
    const [dlgdownloadvisible, setDlgDownloadVisible] = useState<boolean>(false);
    
    const navigate = useNavigate();
    
    const [context] = useState<string>(date + track + raceno.toString());
    const [timefromstart, setTimeFromStart] = useState<string>("");

    /* -------------------------------------------------------------------------------- *\
    |                               getRaceInfos
    \* -------------------------------------------------------------------------------- */
    const getRaceInfos = async (currentdate: string, track: string, race: number) =>
    {
        get_race(currentdate, track, race)
            .then((race: ApiRace) =>
            {
                // setCurrentRace(race);
                var competitors: ApiRunner[] = [];
                for(const comp of race.competitors)
                {
                    competitors[comp.number] = comp;
                }
                setCompetitors(competitors);
            })
            .catch(error =>
            {
                if (error.status === 403) navigate('/login');
                message.error(error.message);
            });
    }

    /* -------------------------------------------------------------------------------- *\
    |                               ws_connect
    \* -------------------------------------------------------------------------------- */
    const ws_connect = (ws: WebClient) => 
    {
        ws.send_cmd("setrace", { date: date, track: track, raceno: raceno, token: getToken() });
    }
    /* -------------------------------------------------------------------------------- *\
    |                               ws_onmessage
    \* -------------------------------------------------------------------------------- */
    const ws_onmessage = (cmd: string, datas: any) => 
    {
        if (cmd === "close")
        {
            ws.current.close();
        }
        if (cmd === "infosfull")
        {
            setRaces(datas as RaceDatas);
        }
        if (cmd === "infossmall")
        {
            setRacessmall(datas as RaceDatas);
        }
        if (cmd === "downloadprogress")
        {
            setDownloadprogress(datas as number);
        }
        if (cmd === "downloadstate")
        {
            const now = formatdateYYYYMMDD(new Date());
            setDownstate(datas);
            if (now !== date)
            {
                setShowplayer(true);
                setDlgDownloadVisible(datas !== "ready");
            }
            else
            {
                setDlgDownloadVisible(datas !== "ready" && datas !== "file not found");
            }
        }
        if (cmd === "showplayer")
        {
            setShowplayer(datas === 'true');
            if (datas === 'true') setDlgDownloadVisible(downstate !== "ready");
        }
    }
    const ws = useRef<WebClient>(new WebClient(ws_connect, ws_onmessage));

    /* -------------------------------------------------------------------------------- *\
    |                               closeSocket
    \* -------------------------------------------------------------------------------- */
    const closeSocket = () => 
    {
        ws.current.close();
    }

    /* -------------------------------------------------------------------------------- *\
    |                               dlgdownloadclose
    \* -------------------------------------------------------------------------------- */
    function dlgdownloadclose(save: boolean)
    {
        setDlgDownloadVisible(false);
        if (!save)
        {
            navigate('/');
        }
    }

    /* -------------------------------------------------------------------------------- *\
    |                               useEffect
    \* -------------------------------------------------------------------------------- */
    useEffect(() =>
    {
        if (ws.current)
        {
            ws.current.connect();
        }
        window.addEventListener('beforeunload', closeSocket);
        return () =>
        {
            window.removeEventListener('beforeunload', closeSocket);
        }
    }, []);

    useEffect(() => {
        setLoading(true);
        getRaceInfos(date, track, raceno).then(() => setLoading(false));
        // eslint-disable-next-line
    }, [context])

    useEffect(() =>
    {
        const currace = races;
        setRaceDatas(currace ? currace : null);
    }, [races, date, track, raceno]);

    useEffect(() =>
    {
        var newraces = racessmall;
        if (!newraces) return;
        if (!races) return;
        for (let pos of newraces.positions)
        {
            const fpos = races.positions.find((p: RunnerPosition) => p.number === pos.number);
            if (fpos)
            {
                if (!newraces.started)
                {
                    if (!newraces.finished)
                    {
                        pos.speeds.beforespeeds = [...fpos.speeds.beforespeeds.slice(1), ...pos.speeds.beforespeeds];
                        pos.speeds.beforehrs = [...fpos.speeds.beforehrs.slice(1), ...pos.speeds.beforehrs];
                    }
                    else
                    {
                        pos.speeds.beforespeeds = fpos.speeds.beforespeeds;
                        pos.speeds.beforehrs = fpos.speeds.beforehrs;
                    }
                    pos.speeds.racespeeds = fpos.speeds.racespeeds;
                }
                else
                {
                    pos.speeds.beforespeeds = fpos.speeds.beforespeeds;
                    pos.speeds.beforehrs = fpos.speeds.beforehrs;
                    pos.speeds.racespeeds = [...fpos.speeds.racespeeds, ...pos.speeds.racespeeds];
                }
            }
        }
        setRaces(newraces);
        // eslint-disable-next-line
    }, [racessmall]);

    useEffect(() =>
    {
        const handleResize = () => {
            if (window.innerWidth > 1024)
            {
                MAP_OPTIONS.gestureHandling = "greedy";
            }
            else
            {
                MAP_OPTIONS.gestureHandling = "cooperative";
            }
        }
        handleResize();

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, []);


    const [top5, setTop5] = useState<RunnerPosition[]>([]);
    useEffect(() =>
    {
        const t5 = racedatas ? racedatas.positions.sort((a: RunnerPosition, b: RunnerPosition) =>
        {
            if(a.rank === 0) return 1;
            if(b.rank === 0) return -1;
            return a.rank - b.rank
        }) : [];
        
        setTop5(t5);

        if (follow && racedatas)
        {
            var lat = 1000;
            var lng = 1000;
            var count = 0;
            for (const position of t5)
            {
                if (position.lat && position.lng)
                {
                    if (lat === 1000)
                    {
                        lat = position.lat;
                        lng = position.lng;
                    }
                    else
                    {
                        lat += position.lat;
                        lng += position.lng;
                    }
                    count++;
                }
            }
            if (count > 0)
            {
                lat /= count;
                lng /= count;

                if (g_lat === 0 && g_lng === 0)
                {
                    g_lat = lat;
                    g_lng = lng;
                }
                else if ((Math.abs(lat - g_lat) > 0.01) || (Math.abs(lng - g_lng) > 0.01))
                {
                    g_lat = lat;
                    g_lng = lng;
                }
                else
                {
                    const coef: number = racedatas.started ? 2 :10;
                    g_lat = g_lat + (lat - g_lat) / coef;
                    g_lng = g_lng + (lng - g_lng) / coef;
                }

                setCenter({ lat: g_lat, lng: g_lng });
            }
        }

        if (racedatas)
        {
            var nspeeds = speeds.splice(0);
            for(const position of racedatas.positions)
            {
                var fdata = nspeeds.find(n => n.number === position.number);
                if (!fdata)
                {
                    fdata = new RunnerSpeedDatas();
                    fdata.number = position.number;
                    nspeeds.push(fdata);
                }
                fdata.speeds = position.speeds;
                if (!racedatas.started || position.rank > 0)
                {
                    const is = position.speeds.maxspeed;
                    if (is > RunnerSpeedDatas.maxspeed)
                    {
                        RunnerSpeedDatas.maxspeedkmh = Math.floor(is * 3.6 / 5) * 5 + 5;
                        RunnerSpeedDatas.maxspeed = RunnerSpeedDatas.maxspeedkmh / 3.6;
                    }
                    fdata.speed = position.speeds.smoothspeed;
                    fdata.hr = position.hr;

                    const hr = position.speeds.maxhr;
                    if (hr > RunnerSpeedDatas.maxhr)
                    {
                        RunnerSpeedDatas.maxhr = hr;
                    }
                }
                else
                {
                    fdata.speed = 0;
                }
            }
            setSpeeds(nspeeds);

            if (racedatas.tspcdep > 0 && racedatas.ts < racedatas.tspcdep)
            {
                setTimeFromStart(String(Math.round((racedatas.tspcdep - racedatas.ts) / 1000)));
            }
            else
            {
                setTimeFromStart("");
            }
        }
    // eslint-disable-next-line
    }, [racedatas]);

    const [center, setCenter] = useState(MAP_CENTER);
    const [follow, setFollow] = useState<boolean>(true);
    const zoom = MAP_ZOOM;
    const options = MAP_OPTIONS;

    const [width] = useState(MAP_STYLE.width);
    const [height] = useState(MAP_STYLE.height);

    var dd: Date = new Date();
    if (date) dd = new Date (Date.parse(date.substring(0, 4) + '-' + date.substring(4, 6) + '-' + date.substring(6, 8)));
    const formateddate: string = !isNaN(dd.getTime()) && date ? dd.toLocaleDateString()  : '';
//
    return (
        <RacesContext.Provider value={races}>
            <SpeedsContext.Provider value={speeds}>
            <LayoutSite>
                <div className="race">
                    {loading ? <Loader /> : <></>}

                    <div className="race__header">
                        <h1 className="race__header__title__desktop">{'C' + raceno + " " + track + ' ' + formateddate}</h1>

                    </div>

                    <div className="race__header__columns">
                        <div className="race__header__column__left">
                            <h1 className="race__header__column__title">{'C' + raceno + " " + track + ' ' + formateddate}</h1>
                            {
                                racedatas && <p className="race__header__column__subtitle"> - Race : { racedatas  ? racedatas.showeddistance + "m" : ""}</p>
                            }
                        </div>
                        <div className="race__header__column">
                            <Progress racedatas={racedatas} timefromstart={timefromstart} />
                            {
                                !showplayer ? <></> : <RacePlayer ws={ws} timefromstart={timefromstart} />
                            }
                        </div>
                    </div>

                    <div className="race__content">
                        <div className="race__content__line">
                            <Top5 competitors={competitors} racedatas={racedatas} top5={top5} />
                            <div className='race__content__map'>
                                <LoadScript googleMapsApiKey={API_KEY} >
                                    <GoogleMap
                                        id='pilotageMap'
                                        mapContainerStyle={{
                                            width,
                                            height,
                                        }}
                                        zoom={zoom}
                                        center={center}
                                        options={options}>
                                        {
                                            top5.map(position =>
                                                <Marker
                                                    key={'marker_' + position.number}
                                                    position={{ lat: position.lat, lng: position.lng }}
                                                    icon={{ url: getMarkerIcon(position.number, findcolor(position.number)), anchor: new window.google.maps.Point(10, 10) }}
                                                />
                                            )
                                        }
                                    </GoogleMap>
                                </LoadScript>
                                <div className='race__content__map__toolbar'>
                                    <div>follow</div>
                                    <Switch size="small" checked={follow} onChange={() => setFollow(!follow)} />
                                </div>
                            </div>
                        </div>
                        <div className='race__content__datas'>
                            <div className="race__content__datas__tabs">
                                <div className='race__content__datas__tabs__toolbar'>
                                    <div className={'race__content__datas__tabs__toolbar__button' + (currenttab === "speeds" ? " race__content__datas__tabs__toolbar__button__active" : "")} onClick={() => setCurrentTab("speeds")}>Speeds</div>
                                    <div className={'race__content__datas__tabs__toolbar__button' + (currenttab === "sections" ? " race__content__datas__tabs__toolbar__button__active" : "")} onClick={() => setCurrentTab("sections")}>Sections</div>
                                    <div className={'race__content__datas__tabs__toolbar__button' + (currenttab === "gaps" ? " race__content__datas__tabs__toolbar__button__active" : "")} onClick={() => setCurrentTab("gaps")}>Gaps</div>
                                    <div className={'race__content__datas__tabs__toolbar__button' + (currenttab === "ranking" ? " race__content__datas__tabs__toolbar__button__active" : "")} onClick={() => setCurrentTab("ranking")}>Ranking</div>
                                </div>
                                <div className="race__content__datas__tabs__bottom">
                                {
                                    (racedatas && currenttab === "sections") ? <Sections race={racedatas} /> : <></>
                                }
                                {
                                    (racedatas && currenttab === "gaps") ? <Distances race={racedatas} /> : <></>
                                }
                                {
                                    (racedatas && currenttab === "speeds") ? <Speeds race={racedatas} /> : <></>
                                }
                                {
                                    (racedatas && currenttab === "ranking") ? <Ranking race={racedatas} /> : <></>
                                }
                                </div>
                            </div>
                        </div>
                    </div>
                    <Modal className='race__modal'
                            width={400}
                            title={"Import race data"}
                            open={dlgdownloadvisible}
                            closable={false}
                            footer={[<Button key="back" onClick={() => dlgdownloadclose(false)}>Close</Button>]}
                            onOk={() => dlgdownloadclose(true)}
                            onCancel={() => dlgdownloadclose(false)}>
                        <div className='race__modal__content'>
                            <div>{downstate}</div>
                            <div style={{ marginTop: 12, background: '#333', borderRadius: 4, overflow: 'hidden', height: 8 }}>
                                <div style={{ width: getDownloadPct(downstate, downloadprogress) + '%', height: '100%', background: downstate.startsWith('error') ? '#c00' : '#1677ff', transition: 'width 0.4s ease' }} />
                            </div>
                        </div>
                    </Modal>
                </div>
            </LayoutSite>
            </SpeedsContext.Provider>
        </RacesContext.Provider>
    );
}
